// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Input from 'share/components/controls/Izenda.Input';
import action from './Izenda.PermissionReportActions';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import { isNil } from 'lodash/fp';
import IzendaSwitch from 'share/components/controls/Izenda.Switch';

const NUMBER_ZERO = 0;

const PermissionReportHeader = (props: any) => {
  const {
    permission: { isTenantSetup },
    localization,
    permissionStore: { tenantDetail },
    authorization,
    readOnly,
    isTemplatePermissions,
    permission: { reports }
  } = props;
  const hasNlqLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq);
  const hasReportDesignerLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.ReportDesigner);
  const hasChartingLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Charting);
  const hasFormLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Form);
  const hasMapLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Maps);

  return (
    <GridLayout className='izenda-GridLayout-Custom'>
      {hasReportDesignerLicense &&
        (isNil(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.canCreateNewReport)) && (
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
              {localization.getText('PERMISSION_LABEL_CAN_CREATE_REPORT')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.canCreateNewReport.value)}
                  onChange={props.permissionUpdateData(reports.canCreateNewReport, 'value')}
                />
              </div>
            </GridLayout.Col>
            {isTenantSetup && (
              <GridLayout.Col cols={1} className='u_textCenter'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.canCreateNewReport.tenantAccess)}
                  onChange={props.permissionUpdateTenantAccess(reports, reports.canCreateNewReport)}
                />
              </GridLayout.Col>
            )}
          </GridLayout.Row>
        )}
        {hasNlqLicense &&
          (isNil(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.showExploreMenu)) && (
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
              {localization.getText('PERMISSION_LABEL_SHOW_EXPLORE_MENU')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.showExploreMenu.value)}
                  onChange={props.permissionUpdateData(reports.showExploreMenu, 'value')}
                />
              </div>
            </GridLayout.Col>
            {isTenantSetup && (
              <GridLayout.Col cols={1} className='u_textCenter'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.showExploreMenu.tenantAccess)}
                  onChange={props.permissionUpdateTenantAccess(reports, reports.showExploreMenu)}
                />
              </GridLayout.Col>
            )}
          </GridLayout.Row>
        )}

      {hasReportDesignerLicense &&
        (isNil(tenantDetail) || tenantDetail.reports.dataSources.tenantAccess !== NUMBER_ZERO) && (
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
              {localization.getText('PERMISSION_LABEL_DATA_SOURCES')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                <label>
                  <Input
                    type='radio'
                    readOnly={readOnly}
                    disabled={isTemplatePermissions}
                    name='datasource'
                    checked={props.getCheckedCommon(reports.dataSources.simpleDataSources)}
                    onChange={props.onChangeSimpleDataSource}
                  />
                  <span>{localization.getText('PERMISSION_LABEL_SIMPLE_DATA_SOURCES')}</span>
                </label>
              </div>
              <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                <label>
                  <Input
                    type='radio'
                    readOnly={readOnly}
                    disabled={isTemplatePermissions}
                    name='datasource'
                    checked={props.getCheckedCommon(reports.dataSources.advancedDataSources)}
                    onChange={props.onChangeAdvancedDataSource}
                  />
                  <span>{localization.getText('PERMISSION_LABEL_ADVANCED_DATA_SOURCES')}</span>
                </label>
              </div>
            </GridLayout.Col>
            {isTenantSetup && (
              <GridLayout.Col cols={1} className='u_textCenter'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.dataSources.tenantAccess)}
                  onChange={props.permissionUpdateTenantAccess(reports, reports.dataSources)}
                />
              </GridLayout.Col>
            )}
          </GridLayout.Row>
        )}
      {hasReportDesignerLicense &&
        (isNil(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportPartTypes)) && (
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
              {localization.getText('PERMISSION_LABEL_REPORT_PART_TYPES')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              {hasChartingLicense && (isNil(tenantDetail) || tenantDetail.reports.reportPartTypes.chart) && (
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <label>
                    <Input
                      type='checkbox'
                      readOnly={readOnly}
                      disabled={isTemplatePermissions}
                      checked={props.getCheckedCommon(reports.reportPartTypes.chart)}
                      onChange={props.permissionUpdateData(reports.reportPartTypes, 'chart')}
                    />
                    <span>{localization.getText('PERMISSION_LABEL_CHART')}</span>
                  </label>
                </div>
              )}
              {hasFormLicense && (isNil(tenantDetail) || tenantDetail.reports.reportPartTypes.form) && (
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <label>
                    <Input
                      type='checkbox'
                      readOnly={readOnly}
                      disabled={isTemplatePermissions}
                      checked={props.getCheckedCommon(reports.reportPartTypes.form)}
                      onChange={props.permissionUpdateData(reports.reportPartTypes, 'form')}
                    />
                    <span>{localization.getText('PERMISSION_LABEL_FORM')}</span>
                  </label>
                </div>
              )}
              {hasChartingLicense && (isNil(tenantDetail) || tenantDetail.reports.reportPartTypes.gauge) && (
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <label>
                    <Input
                      type='checkbox'
                      readOnly={readOnly}
                      disabled={isTemplatePermissions}
                      checked={props.getCheckedCommon(reports.reportPartTypes.gauge)}
                      onChange={props.permissionUpdateData(reports.reportPartTypes, 'gauge')}
                    />
                    <span>{localization.getText('PERMISSION_LABEL_GAUGE')}</span>
                  </label>
                </div>
              )}
              {hasMapLicense && (isNil(tenantDetail) || tenantDetail.reports.reportPartTypes.map) && (
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <label>
                    <Input
                      type='checkbox'
                      readOnly={readOnly}
                      disabled={isTemplatePermissions}
                      checked={props.getCheckedCommon(reports.reportPartTypes.map)}
                      onChange={props.onMapChange(reports.reportPartTypes, 'map')}
                    />
                    <span>{localization.getText('PERMISSION_LABEL_MAP')}</span>
                  </label>
                </div>
              )}
              {hasChartingLicense && (isNil(tenantDetail) || tenantDetail.reports.reportPartTypes.kpi) && (
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <label>
                    <Input
                      type='checkbox'
                      readOnly={readOnly}
                      disabled={isTemplatePermissions}
                      checked={props.getCheckedCommon(reports.reportPartTypes.kpi)}
                      onChange={props.permissionUpdateData(reports.reportPartTypes, 'kpi')}
                    />
                    <span>{localization.getText('PERMISSION_LABEL_KPI')}</span>
                  </label>
                </div>
              )}
            </GridLayout.Col>
            {isTenantSetup && (
              <GridLayout.Col cols={1} className='u_textCenter'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.reportPartTypes.tenantAccess)}
                  onChange={props.permissionUpdateTenantAccess(reports, reports.reportPartTypes)}
                />
              </GridLayout.Col>
            )}
          </GridLayout.Row>
        )}
      {hasReportDesignerLicense &&
        isTenantSetup &&
        (isNil(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportPartTypes)) &&
        props.getCheckedCommon(reports.reportPartTypes.map) && (
          <GridLayout.Row className='u_paddingTop u_paddingBottom'>
            <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubSubCategory'>
              {localization.getText('PERMISSION_LABEL_ENABLE_GOOGLE_ADDRESS')}
            </GridLayout.Col>
            <GridLayout.Col cols={9}>
              <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                <Input
                  type='checkbox'
                  readOnly={readOnly}
                  disabled={isTemplatePermissions}
                  checked={props.getCheckedCommon(reports.reportPartTypes.isEnableGoogleAddress)}
                  onChange={props.permissionUpdateData(reports.reportPartTypes, 'isEnableGoogleAddress')}
                />
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        )}
      {(isNil(tenantDetail) || props.checkShowGroupCommon(tenantDetail.reports.reportCategoriesSubcategories)) && (
        <GridLayout.Row className='u_paddingTop u_paddingBottom'>
          <GridLayout.Col className='izenda-PermissionCategory-SubCategory'>
            {localization.getText('PERMISSION_LABEL_REPORT_CATEGORIES_SUBCATEGORIES')}
          </GridLayout.Col>
        </GridLayout.Row>
      )}
      {(isNil(tenantDetail) ||
        props.checkShowGroupCommon(tenantDetail.reports.reportCategoriesSubcategories.preventReportSharing)) && (
        <GridLayout.Row className='u_paddingTop u_paddingBottom'>
          <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubSubCategory'>
            {localization.getText('PERMISSION_LABEL_PREVENT_REPORT_SHARING')}
          </GridLayout.Col>
          <GridLayout.Col cols={9}>
            <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
              <IzendaSwitch value={reports.reportCategoriesSubcategories.preventReportSharing.value}
               onChange={props.permissionUpdateData(
                reports.reportCategoriesSubcategories.preventReportSharing,
                'value'
              )} />
            </div>
          </GridLayout.Col>
          {isTenantSetup && (
            <GridLayout.Col cols={1} className='u_textCenter'>
              <Input
                type='checkbox'
                readOnly={readOnly}
                disabled={isTemplatePermissions}
                checked={props.getCheckedCommon(
                  reports.reportCategoriesSubcategories.preventReportSharing.tenantAccess
                )}
                onChange={props.permissionUpdateTenantAccess(
                  reports,
                  reports.reportCategoriesSubcategories.preventReportSharing
                )}
              />
            </GridLayout.Col>
          )}
        </GridLayout.Row>
      )}
      {(isNil(tenantDetail) ||
        props.checkShowGroupCommon(tenantDetail.reports.reportCategoriesSubcategories.canCreateNewCategory)) && (
        <GridLayout.Row className='u_paddingTop u_paddingBottom'>
          <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubSubCategory'>
            {localization.getText('PERMISSION_LABEL_CAN_CREATE_CATEGORY')}
          </GridLayout.Col>
          <GridLayout.Col cols={9}>
            <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
              <Input
                type='checkbox'
                readOnly={readOnly}
                disabled={isTemplatePermissions}
                checked={props.getCheckedCommon(reports.reportCategoriesSubcategories.canCreateNewCategory.value)}
                onChange={props.permissionUpdateData(
                  reports.reportCategoriesSubcategories.canCreateNewCategory,
                  'value'
                )}
              />
            </div>
          </GridLayout.Col>
          {isTenantSetup && (
            <GridLayout.Col cols={1} className='u_textCenter'>
              <Input
                type='checkbox'
                readOnly={readOnly}
                disabled={isTemplatePermissions}
                checked={props.getCheckedCommon(
                  reports.reportCategoriesSubcategories.canCreateNewCategory.tenantAccess
                )}
                onChange={props.permissionUpdateTenantAccess(
                  reports,
                  reports.reportCategoriesSubcategories.canCreateNewCategory
                )}
              />
            </GridLayout.Col>
          )}
        </GridLayout.Row>
      )}
    </GridLayout>
  );
};

PermissionReportHeader.propTypes = {
  permission: PropTypes.object.isRequired
};

export default connect(action)(PermissionReportHeader);



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionReportHeader.js